import type { AxiosError } from 'axios';
import type { CodeStandExceptionResponseModel } from 'src/lib/api';

import { paths } from 'src/routes/paths';

// ----------------------------------------------------------------------

export const ITEM_NOT_FOUND_STORAGE_KEY = 'hr_item_not_found';

export type ItemNotFoundPayload = {
  title: string;
  description: string;
  transactionId?: string;
};

type ItemNotFoundErrorData = Partial<CodeStandExceptionResponseModel> & { Description?: string };

// ----------------------------------------------------------------------

export function readItemNotFoundPayload(): ItemNotFoundPayload | null {
  try {
    const raw = sessionStorage.getItem(ITEM_NOT_FOUND_STORAGE_KEY);
    if (!raw) {
      return null;
    }
    return JSON.parse(raw) as ItemNotFoundPayload;
  } catch {
    return null;
  }
}

export function consumeItemNotFoundPayload(): ItemNotFoundPayload | null {
  const payload = readItemNotFoundPayload();
  sessionStorage.removeItem(ITEM_NOT_FOUND_STORAGE_KEY);
  return payload;
}

export function handleItemNotFoundRedirect(error: AxiosError<ItemNotFoundErrorData>): boolean {
  if (error.response?.status !== 404) {
    return false;
  }

  const data = error.response.data;
  if (data?.Title !== 'ItemNotFound') {
    return false;
  }

  if (window.location.pathname === paths.error.itemNotFound) {
    return false;
  }

  const payload: ItemNotFoundPayload = {
    title: data.Title,
    description: data.Description ?? '',
    transactionId: data.TransactionId,
  };

  sessionStorage.setItem(ITEM_NOT_FOUND_STORAGE_KEY, JSON.stringify(payload));
  window.location.assign(paths.error.itemNotFound);

  return true;
}
